/* eslint-disable no-plusplus */
import { put, call, takeLatest, takeEvery } from "redux-saga/effects";
import { push } from "connected-react-router";

import { PENDING, AUTOMATIC, CONCILIATED, MESSAGES } from "../actions";
import generateAction from "../../utils/action-helpers";

import redirectToLogin from "../../utils/redirect-to-login";

import { fetchPending, deleteTransfer } from "../../api/pending";
import { acceptProposal, createProposal } from "../../api/proposal";
import { messageState } from "../../utils/messajes";

function* fetchPendingSaga(action) {
  try {
    const response = yield call(fetchPending, action.payload);
    yield put(generateAction(PENDING.FETCH_SUCCESS, response.data));
  } catch (err) {
    if (err && err.response && err.response.status === 401) {
      redirectToLogin();
    }
    yield put(generateAction(PENDING.FETCH_ERROR));
  }
}

function* accept(action) {
  const { id } = action.payload;
  try {
    yield call(acceptProposal, id);
    yield put(generateAction(PENDING.FETCH));
    yield put(generateAction(AUTOMATIC.FETCH));
    yield put(generateAction(CONCILIATED.FETCH));
    yield put(generateAction(MESSAGES.PROPOSAL_STATUS, messageState.SUCCESS));
    yield put(push("/"));
  } catch (err) {
    if (err && err.response && err.response.status === 401) {
      redirectToLogin();
    }
    yield put(generateAction(PENDING.GET_ITEMS_ERROR));
  }
}

function* concile(action) {
  const proposal = action.payload;
  try {
    const paymentsClient = [
      ...proposal.paymentsClient.filter(x => !x.ceco),
      ...proposal.paymentsCount.filter(x => !x.ceco)
    ];
    const paymentsCount = [
      ...proposal.paymentsClient.filter(x => x.ceco),
      ...proposal.paymentsCount.filter(x => x.ceco)
    ];
    yield call(createProposal, {
      ...proposal,
      paymentsClient,
      paymentsCount
    });
    yield put(generateAction(PENDING.FETCH));
    yield put(generateAction(AUTOMATIC.FETCH));
    yield put(generateAction(CONCILIATED.FETCH));
    yield put(generateAction(MESSAGES.PROPOSAL_STATUS, messageState.SUCCESS));
    yield put(push("/"));
  } catch (err) {
    if (err && err.response && err.response.status === 401) {
      redirectToLogin();
    }

    yield put(generateAction(PENDING.GET_ITEMS_ERROR));
  }
}
function* deleteTransferAllSaga({ payload }) {
  try {
    for (let i = 0; i < payload.length; i++) {
      const itemToDelete = payload[i];
      yield call(deleteTransfer, itemToDelete);
    }
    yield put(generateAction(MESSAGES.DELETE_STATUS, messageState.SUCCESS));
    yield put(generateAction(PENDING.FETCH));
    yield put(generateAction(AUTOMATIC.FETCH));
  } catch (err) {
    if (err && err.response && err.response.status === 401) {
      redirectToLogin();
    }
    yield put(generateAction(MESSAGES.DELETE_STATUS, messageState.ERROR));
  }
}
function* deleteTransferSaga(action) {
  const itemToDelete = action.payload;
  try {
    yield call(deleteTransfer, itemToDelete);
    yield put(generateAction(MESSAGES.DELETE_STATUS, messageState.SUCCESS));
    yield put(generateAction(PENDING.FETCH));
    yield put(generateAction(AUTOMATIC.FETCH));
  } catch (err) {
    if (err && err.response && err.response.status === 401) {
      redirectToLogin();
    }
    yield put(generateAction(MESSAGES.DELETE_STATUS, messageState.ERROR));
  }
}
export default function* pendingSaga() {
  yield takeLatest(PENDING.FETCH, fetchPendingSaga);
  yield takeEvery(PENDING.ACCEPT, accept);
  yield takeEvery(PENDING.CONCILE, concile);
  yield takeEvery(PENDING.DELETE_TRANSFER, deleteTransferSaga);
  yield takeEvery(PENDING.DELETE_TRANSFER_ALL, deleteTransferAllSaga);
}
